import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { listJobs } from '../../../../insfrastructure/services/jobs'
import { StaticValues } from '../../../../insfrastructure/services/static_values'
import { formatExperience } from '../../../../insfrastructure/utils/object-utils'
import searchIcon from '../../../../assets/icons/search.png'

import './styles.sass'

export default class Offers extends Component {
    state: Record<string, any> = {
        job_types: [],
        job_results: [],
        loading_job: false,
        loading_more: false,
        currentPage: 1,
        totalPages: 1,
        totalCount: 0,
        search: '',
        selectedJobType: null,
        filteredJobs: [],
        jobsPerPage: 10,
        filteredTotalCount: 0,
        hasMore: true,
        showBackToTop: false
    }
    
    private searchTimeout: NodeJS.Timeout | null = null

    BRLReal = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    })

    componentWillUnmount() {
        // Limpar timeout para evitar memory leaks
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        // Remover listener de scroll
        window.removeEventListener('scroll', this.handleScroll)
    }

    async componentDidMount() {
        setTimeout(() => {
            this.getStaticValues()
        })

        // Obter parâmetros da URL
        const urlParams = new URLSearchParams(window.location.search)
        const page = parseInt(urlParams.get('page') || '1')
        const search = urlParams.get('search') || ''

        this.setState({ currentPage: page, search })
        await this.loadJobs(page, search)
        
        // Adicionar listener de scroll para infinite scroll
        window.addEventListener('scroll', this.handleScroll)
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        // Removido para evitar conflitos com handlePageChange
        // A paginação agora é controlada apenas pelos handlers
    }

    loadJobs = async (page: number = 1, search: string = '', jobType?: string, append: boolean = false) => {
        try {
            if (append) {
                this.setState({ loading_more: true })
            } else {
                this.setState({ loading_job: true })
            }
            
            const offset = (page - 1) * this.state.jobsPerPage
            const params: any = { offset, limit: this.state.jobsPerPage }
            
            if (search) {
                params.search = search
            }
            
            if (jobType) {
                params.jobType = jobType
            }

            const response = await listJobs(params)
            
            if (append) {
                // Adicionar novos jobs aos existentes
                this.setState({
                    job_results: [...this.state.job_results, ...response.data],
                    totalCount: response.totalCount,
                    totalPages: Math.ceil(response.totalCount / this.state.jobsPerPage),
                    loading_more: false,
                    filteredJobs: [...this.state.filteredJobs, ...response.data],
                    filteredTotalCount: response.totalCount,
                    hasMore: response.data.length === this.state.jobsPerPage
                })
            } else {
                // Substituir jobs existentes (nova busca/filtro)
                this.setState({
                    job_results: response.data,
                    totalCount: response.totalCount,
                    totalPages: Math.ceil(response.totalCount / this.state.jobsPerPage),
                    loading_job: false,
                    filteredJobs: response.data,
                    filteredTotalCount: response.totalCount,
                    hasMore: response.data.length === this.state.jobsPerPage,
                    currentPage: 1
                })
            }
        } catch (error) {
            console.error('Erro ao carregar vagas:', error)
            this.setState({ loading_job: false, loading_more: false })
        }
    }

    getStaticValues = async () => {
        try {
            const staticValues = JSON.parse(localStorage.getItem('static_values') + '') as StaticValues
            const job_types = staticValues.job_type

            console.log('Static values:', staticValues)
            console.log('Job types loaded:', job_types)
            console.log('Job types structure:', JSON.stringify(job_types, null, 2))
            this.setState({ job_types })
        } catch (error) {
            console.log('Error loading job types:', error)
        }
    }

    handleScroll = () => {
        const scrollTop = document.documentElement.scrollTop
        
        // Mostrar/esconder botão "Voltar ao topo"
        this.setState({ showBackToTop: scrollTop > 500 })
        
        // Verificar se chegou no final da página para carregar mais
        if (window.innerHeight + scrollTop >= document.documentElement.offsetHeight - 1000) {
            this.loadMoreJobs()
        }
    }

    loadMoreJobs = () => {
        if (!this.state.loading_more && this.state.hasMore) {
            const nextPage = this.state.currentPage + 1
            this.setState({ currentPage: nextPage }, () => {
                // Converter para uppercase para o GraphQL
                const graphqlJobType = this.state.selectedJobType ? this.state.selectedJobType.toUpperCase() : undefined
                this.loadJobs(nextPage, this.state.search, graphqlJobType, true)
            })
        }
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }

    handleJobTypeFilter = (jobType: string) => {
        const newSelectedJobType = this.state.selectedJobType === jobType ? null : jobType
        this.setState({ 
            selectedJobType: newSelectedJobType,
            currentPage: 1 
        }, () => {
            // Converter para uppercase para o GraphQL
            const graphqlJobType = newSelectedJobType ? newSelectedJobType.toUpperCase() : undefined
            // Recarregar jobs da API com o filtro aplicado
            this.loadJobs(1, this.state.search, graphqlJobType)
        })
    }



    getCurrentPageJobs = () => {
        // Como agora fazemos paginação na API, retornamos todos os jobs da página atual
        return this.state.job_results
    }







    handleSearchChange = (value: string) => {
        this.setState({ search: value, currentPage: 1 })
        
        // Debounce da busca para evitar requisições excessivas
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout)
        }
        
        this.searchTimeout = setTimeout(() => {
            // Atualizar URL
            this.updateURL({ page: 1, search: value })
            // Converter para uppercase para o GraphQL
            const graphqlJobType = this.state.selectedJobType ? this.state.selectedJobType.toUpperCase() : undefined
            // Carregar jobs (resetar lista)
            this.loadJobs(1, value, graphqlJobType)
        }, 300)
    }

    updateURL = (params: { page?: number; search?: string }) => {
        const url = new URL(window.location.href)
        
        if (params.page !== undefined) {
            url.searchParams.set('page', params.page.toString())
        }
        
        if (params.search !== undefined) {
            if (params.search) {
                url.searchParams.set('search', params.search)
            } else {
                url.searchParams.delete('search')
            }
        }

        // Atualizar URL sem recarregar a página
        window.history.pushState({}, '', url.toString())
    }

    renderLoadMore = () => {
        const { loading_more, hasMore, job_results } = this.state
        
        // Não mostrar se não há jobs
        if (job_results.length === 0) return null
        
        // Não mostrar se não há mais jobs para carregar
        if (!hasMore) {
            return (
                <div className="load-more-container">
                    <div className="end-message">
                        <p>🎉 Você viu todas as vagas disponíveis!</p>
                    </div>
                </div>
            )
        }
        
        // Mostrar indicador de carregamento
        if (loading_more) {
            return (
                <div className="load-more-container">
                    <div className="loading-more">
                        <div className="spinner"></div>
                        <p>Carregando mais vagas...</p>
                    </div>
                </div>
            )
        }
        
        return null
    }

    render() {
        return (
            <div className='offers-page'>
                <div className='content'>
                    <h1>VAGAS DISPONÍVEIS</h1>
                    
                    <div className='job-types'>
                        {Object.entries(this.state.job_types).map(([key, value]: [string, any], i: number) => (
                            <div 
                                key={'job_type_' + i} 
                                className={'job-type ' + (this.state.selectedJobType === key ? 'selected' : '')}
                                onClick={() => this.handleJobTypeFilter(key)}
                            >
                                {value}
                            </div>
                        ))}
                    </div>
                    
                    <div className='oportunities-searcher'>
                        <img className='search-icon' src={searchIcon} alt='search' />
                        <input 
                            type='text' 
                            placeholder='Pesquisar vaga' 
                            value={this.state.search}
                            onChange={(e) => this.handleSearchChange(e.target.value)}
                        />
                    </div>



                    <div className={`job-results ${this.state.transitioning ? 'transitioning' : ''}`}>
                        {!this.state.loading_job ? (
                            <>
                                {this.state.job_results.length === 0 ? (
                                    <div className='no-results'>
                                        <p>Nenhuma vaga encontrada</p>
                                        <p>Tente ajustar os filtros de busca</p>
                                    </div>
                                ) : (
                                    this.getCurrentPageJobs().map((x: any, i: number) => (
                                        <div key={'job_' + i} className='job'>
                                            <div className='top-row'>
                                                <div className='job-info'>
                                                    <div className='main'>
                                                        <h3>{x.jobTitle.name}</h3>
                                                        <p>{x.company.name}</p>
                                                    </div>
                                                    <div className='salary'>
                                                        <p>{x.showSalary ? this.BRLReal.format(x.salary) : 'A combinar'}</p>
                                                    </div>
                                                </div>
                                                {window.innerWidth > 1000 && (
                                                    <div className='sign-in'>
                                                        <Link to={'/offers/' + x.jobpostId + '/details'}>
                                                            <button className='primary'>Ver detalhes</button>
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>
                                            <div className='bottom-row'>
                                                <div className='experience'>
                                                    <p><b>Experiência:</b> {formatExperience(x.minimumExperience)}</p>
                                                </div>
                                                <div className='observations'>
                                                    <p dangerouslySetInnerHTML={{ __html: x.jobDescription }}></p>
                                                </div>
                                                <div className='type'>
                                                    <span>
                                                        {this.state.job_types[x.jobType?.toLowerCase()] || x.jobType || 'Efetiva'}
                                                    </span>
                                                </div>
                                            </div>
                                            {window.innerWidth <= 1000 && (
                                                <div className='sign-in'>
                                                    <Link to={'/offers/' + x.jobpostId + '/details'}>
                                                        <button className='primary'>Ver detalhes</button>
                                                    </Link>
                                                </div>
                                            )}
                                        </div>
                                    ))
                                )}
                            </>
                        ) : (
                            <div className='loading'>
                                <p>Carregando vagas...</p>
                            </div>
                        )}
                    </div>

                    {this.renderLoadMore()}
                </div>
                
                {/* Botão Voltar ao Topo */}
                {this.state.showBackToTop && (
                    <button 
                        className="back-to-top-btn"
                        onClick={this.scrollToTop}
                        title="Voltar ao topo"
                    >
                        ↑
                    </button>
                )}
            </div>
        )
    }
}